import Card from '@/components/Card'
import SvgLoadingSpin from '@/components/SvgLoadingSping'
import { configs } from '@/configs'
import * as React from 'react'
import { useViewTheme } from '../theme'
import { cn } from '@/utils/style'

type CaptchaProps = {
  onTokenResponse: (token: string) => Promise<void>
  revalidate?: boolean
}

declare global {
  interface Window {
    grecaptcha: any
  }
}

export function CaptchaGetter(props: CaptchaProps) {
  function loadKey() {
    window.grecaptcha
      .execute(`${configs.CAPTCHA_SITE_KEY}`, { action: 'homepage' })
      .then((token: string) => {
        // console.log('TOKEN', token)
        props.onTokenResponse(token)
        if (props.revalidate) {
          setTimeout(() => {
            loadKey()
            // expiry is every 3 min, reload every 2 min
          }, 120 * 1000)
        }
      })
  }

  const handleLoaded = () => {
    window.grecaptcha.ready(() => {
      loadKey()
    })
  }

  React.useEffect(() => {
    // Add reCaptcha
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${configs.CAPTCHA_SITE_KEY}`
    script.addEventListener('load', handleLoaded)
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div
      className="g-recaptcha"
      data-sitekey={`${configs.CAPTCHA_SITE_KEY}`}
      data-size="invisible"
      // invisible, compact, normal
    />
  )
}

export default function Captcha(props: CaptchaProps) {
  const theme = useViewTheme()

  return (
    <div className="bg-slate-50 w-full h-screen">
      <div
        className={cn({
          'pt-20': !theme,
          'pt-4': theme,
        })}
      >
        <Card className="font-medium text-slate-700 max-w-6xl p-8 flex gap-4 flex-col text-center mx-auto">
          <p>Verificando que você não é um robô</p>
          <div className="mx-auto w-full flex justify-evenly">
            <SvgLoadingSpin color="dark" />
          </div>
          {/* <p>{configs.CAPTCHA_SITE_KEY}</p> */}
        </Card>
      </div>
      <CaptchaGetter {...props} />
    </div>
  )
}
